import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/comics";
import { siteInfo } from "@/mocks/comics";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 font-bold text-xl no-underline"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg">
              <i className="ri-book-read-line"></i>
            </span>
            <span className="text-foreground-950">{siteInfo.name}</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 7).map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === "all" ? "/" : `/category/${cat.slug}`}
                className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer no-underline ${
                  (cat.slug === "all" && location.pathname === "/") ||
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer no-underline ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === "all" ? "/" : `/category/${cat.slug}`}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm no-underline transition-colors ${
                  (cat.slug === "all" && location.pathname === "/") ||
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                <i className={`${cat.icon} w-5 h-5 flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm no-underline transition-colors ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <i className="ri-information-line w-5 h-5 flex items-center justify-center"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}